import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function DeleteClose({
  attributes = {
    color: "",
    classes: "",
    size: "24",
  },
  clickHandler,
}) {
  const navigate = useNavigate();

  return (
    <div className={attributes.classes} onClick={clickHandler}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={attributes.size}
        height={attributes.size}
        viewBox="0 0 38 38"
      >
        <path
          id="closeicon"
          d="M21,2A19,19,0,1,0,40,21,19.031,19.031,0,0,0,21,2Zm6.384,23.37a1.434,1.434,0,0,1,0,2.014,1.422,1.422,0,0,1-2.014,0L21,23.014l-4.37,4.37a1.422,1.422,0,0,1-2.014,0,1.434,1.434,0,0,1,0-2.014L18.986,21l-4.37-4.37a1.424,1.424,0,0,1,2.014-2.014L21,18.986l4.37-4.37a1.424,1.424,0,0,1,2.014,2.014L23.014,21Z"
          transform="translate(-2 -2)"
          fill={attributes.color}
        />
      </svg>
    </div>
  );
}
